import React, { Component } from "react";
import {
    Container,
    Card,
    CardHeader,
    Row,
    Col,
    Badge,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Input
} from "reactstrap";
import { Button as Button1, Message, Icon, Header, Modal as Modal1, Tab, Label, Menu, Table, Popup } from 'semantic-ui-react'
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ListGroupCollapse from "../../common/ListGroupCollapse";
import { Link, withRouter } from "react-router-dom";
import RXInfo from "../Prescription/RXInfo";
import Markers from "../Prescription/Markers";
import PrescriptionHistory from "../Prescription/PrescriptionHistory";
import { getPrescriptions, postPrescriptions, getPrescriptionHistory, getPrescriptionByNumber, editingPrescriptions, presc_modal_view, getDurInfo } from "../../../actions/mqttAction";
import Spinner from "../../common/Spinner";
import _ from "lodash";
import Allergies from "../Prescription/Allergies";
import Warnings from "../Prescription/Warnings";
import Magnifier from "react-magnifier";

class PendingView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapse: false,
            headers: {},
            modal: false,
            rejectModal: false,
            ndcImage: "",
            rejectReason: "",
            showDur: false,
            searchList: [],
            search: false,
            searchTerm: "",
            requireConsult: false,
            ppmRequired: false,
            prescriptionByNumber: {},
            showAllergyModal: false,
            modalPdf: "",
            isValidFilee: '',
            fileTypee: '',
            base64Dataa: ''
        };
        this.showDUR = this
            .showDUR
            .bind(this)

        this.toggleDurModal = this.toggleDurModal.bind(this);
        this.checked = this
            .checked
        this.onChange = this
            .onChange
            .bind(this);
        this.toggle = this
            .toggle
            .bind(this);
        this.approve = this
            .approve
            .bind(this);
        this.reject = this
            .reject
            .bind(this);
        this.pmpRequired = this
            .pmpRequired
            .bind(this);
        this.toggleModal = this
            .toggleModal
            .bind(this);
        this.rejectModal = this
            .rejectModal
            .bind(this);
        this.in_editing = this
            .in_editing
            .bind(this);
    }
    openAllergyModal = () => {
        const prescription = this.state.prescriptionByNumber;
        const notes = prescription?.patientInfo?.patientAdditionalInfo?.notes || '';
        const fileUrl = notes?.split(' , ')[0]?.trim();
        const fileType = this.getFileTypeFromUrl(fileUrl);
        const isValidFile = fileType !== 'unknown';
        this.setState({
            showAllergyModal: true,
            base64Dataa: fileUrl,
            fileTypee: fileType,
            isValidFilee: isValidFile,
        });
    };

    closeAllergyModal = () => {
        this.setState({ showAllergyModal: false });
    };

    componentDidMount() {
        let orgId;
        if (this.props.auth.user.orgId)
            orgId = this.props.auth.user.orgId;
        else
            orgId = 1;
        let branchName;
        localStorage.branch
            ? (branchName = localStorage.branch)
            : (branchName = "Chama");

        this
            .props
            .getPrescriptionByNumber(orgId, `branchName=${this.props.prescription[0].branchName}`, this.props.prescriptionNumber, this.props.prescription[0].prescriptionStatus);
        this
            .props
            .getPrescriptionHistory(orgId, `${this.props.prescription[0].branchName}`, this.props.patientId);
        var editing = "edit";

        editing === "view"
            ? this.setState({ editing: false })
            : this.setState({ editing: true });
    }

    handleChecked(e) {
        if (e.target.name === "requireConsult")
            this.setState({
                requireConsult: !this.state.requireConsult
            });
    }

    in_editing = p_number => {
        let orgId;
        if (this.props.auth.user.orgId)
            orgId = this.p_number;
        else
            orgId = 1;
        let pending = p_number;
        if (this.props.auth.user.roles[0] === "PHARMACIST" && !pending.isEditing) {
            pending.isEditing = true;
            pending.pharmacistInfo.name = this.props.auth.user.sub;
            this
                .props
                .editingPrescriptions(orgId, pending);
        }
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        let headers = {};
        if (Object.keys(nextProps.mqtt.prescriptionByNumber).length > 0) {
            if (nextProps.mqtt.prescriptionByNumber.durInfo
                && nextProps.mqtt.prescriptionByNumber.durInfo.interactionCount && !this.state.durInfo) {
                this
                    .props
                    .getDurInfo(nextProps.mqtt.prescriptionByNumber);
            }
            if (Object.keys(nextProps.mqtt.durInfo).length > 0) {
                this.setState({ durInfo: nextProps.mqtt.durInfo });
            }
            const prescriptionByNumber = nextProps.mqtt.prescriptionByNumber;
            // this.in_editing(prescriptionByNumber);
            const prescriptionHistory = nextProps.mqtt.prescriptionHistory;
            let ndcImage;
            prescriptionByNumber
                .prescriptionImageUrls
                .forEach(images => {

                    if (images.imageType === "ndcPillImage") {
                        console.log("=========NDC IMAGE+============" + images.imageUrl);
                        ndcImage = "" + images.imageUrl;
                        // /console.log("=======NDC Image==========="+ndcImage)
                        this.setState({ ...this.state, ndcImage: ndcImage });
                        //imageLabels.unshift(images)
                    }
                    // if (images.imageType === "ndcPillImage") 
                    //     ndcImage = ""+images.imageUrl;
                    // this.setState({ndcImage: ndcImage});
                }

                );

            headers.prescriptionDetails = {
                header: "Prescription Details",
                content: (<RXInfo
                    draft={prescriptionByNumber}
                    style={{
                        backgroundColor: "#fff"
                    }} />)
            };
            headers.markers = {
                header: "Markers",
                content: (<Markers prescription={prescriptionByNumber.patientInfo.patientAdditionalInfo} prescriptionStatus={prescriptionByNumber.prescriptionStatus} />)
            };
            headers.medicationHistory = {
                header: "Medication History",
                content: (
                    <div>
                        {!_.isEmpty(prescriptionHistory.medicationHistory)
                            ? (<PrescriptionHistory
                                prescriptionHistory={prescriptionHistory}
                                prescriberInfo={prescriptionByNumber.prescriberInfo} />)
                            : (
                                <span>No medication history available</span>
                            )}
                    </div>
                )
            };
            headers.allergies = {
                header: "Allergies",
                content: (
                    <div>
                        {!_.isEmpty(prescriptionHistory.allergies)
                            ? (<Allergies prescriptionHistory={prescriptionHistory} />)
                            : (
                                <span>No allergies available</span>
                            )}
                    </div>
                )
            };
            headers.warnings = {
                header: "Warnings",
                content: (
                    <div>
                        {!_.isEmpty(prescriptionHistory.warnings)
                            ? (<Warnings prescriptionHistory={prescriptionHistory} />)
                            : (
                                <span>No warnings available</span>
                            )}
                    </div>
                )
            };
            headers.auditLogs = {
                header: "Audit Logs",
                content: (
                    <ul>
                        {prescriptionByNumber
                            .auditLogs
                            .map(auditLog => (
                                <li key={auditLog}>{auditLog}</li>
                            ))}
                    </ul>
                )
            };
            if (Object.keys(nextProps.mqtt.durInfo).length > 0) {
                this.setState({ durInfo: nextProps.mqtt.durInfo });
            }
            this.setState({
                ...this.state,
                headers: headers,
                prescriptionByNumber: this.props.mqtt.prescriptionByNumber
            });
        }
    }


    showDUR(toShow) {
        this.setState({
            ...this.state,
            showDur: toShow
        })
    }
    closeDur() {
    }

    toggleDurModal() {
        let toShow = this.state.showDur;
        this.setState({
            ...this.state,
            showDur: !toShow
        })
    }

    getDurModal() {

        let prescription = this.props.mqtt.prescriptionByNumber;
        let durModal = <div></div>

        if (this.props.mqtt.prescriptionByNumber && Object.keys(prescription).length > 0) {

            if (prescription && prescription.durInfo) {
                let mbody = ""
                var ReactDOMServer = require('react-dom/server');
                var HtmlToReactParser = require('html-to-react').Parser;
                var htmlToReactParser = new HtmlToReactParser();

                //var reactElement = htmlToReactParser.parse(this.state.durInfo.professionalMonograph);
                var reactElement = htmlToReactParser.parse(this.state.durInfo ? this.state.durInfo.professionalMonograph : '<html></html');

                let modalBody;
                let severityLevel = prescription.durInfo.seviorityLevel

                if (severityLevel === "Major") {
                    modalBody = <div className="dur-interactions-headings">
                        <Row>
                            <Col md="5" lg="5" className="text-center ml-2">
                                <strong><h4 > Interraction Count : <span style={{ color: "teal", fontSize: "1.5rem" }}>{prescription.durInfo.interactionCount}</span></h4></strong>
                            </Col>
                            <Col md="1" lg="1">
                            </Col>
                            <Col md="5" lg="5" className="text-center mr-2">
                                <strong><h4 > Severity : <span className=" text-capitalize" style={{ color: "red", fontSize: "1.5rem" }}>{prescription.durInfo.seviorityLevel}</span></h4></strong>
                            </Col>
                        </Row>


                        {reactElement}
                    </div>
                }
                else if (severityLevel === "medium") {
                    modalBody = <div className="dur-interactions-headings">
                        <Row>
                            <Col md="5" lg="5" className="text-center ml-2">
                                <strong><h4 > Interraction Count : <span style={{ color: "teal", fontSize: "1.5rem" }}>{prescription.durInfo.interactionCount}</span></h4></strong>
                            </Col>
                            <Col md="1" lg="1">
                            </Col>
                            <Col md="5" lg="5" className="text-center mr-2">
                                <strong><h4 > Severity : <span className=" text-capitalize" style={{ color: "orange", fontSize: "1.5rem" }}>{prescription.durInfo.seviorityLevel}</span></h4></strong>
                            </Col>
                        </Row>


                        {reactElement}
                    </div>
                }
                else if (severityLevel === "low") {
                    modalBody = <div className="dur-interactions-headings">
                        <Row>
                            <Col md="5" lg="5" className="text-center ml-2">
                                <strong><h4 > Interraction Count : <span style={{ color: "teal", fontSize: "1.5rem" }}>{prescription.durInfo.interactionCount}</span></h4></strong>
                            </Col>
                            <Col md="1" lg="1">
                            </Col>
                            <Col md="5" lg="5" className="text-center mr-2">
                                <strong><h4 > Severity : <span className=" text-capitalize" style={{ color: "#007bff", fontSize: "1.5rem" }}>{prescription.durInfo.seviorityLevel}</span></h4></strong>
                            </Col>
                        </Row>


                        {reactElement}
                    </div>
                }
                else if (severityLevel === "Unknown") {
                    modalBody = <div className="dur-interactions-headings">
                        <Row>
                            <Col md="5" lg="5" className="text-center ml-2">
                                <strong><h4 > Interraction Count : <span style={{ color: "teal", fontSize: "1.5rem" }}>{prescription.durInfo.interactionCount}</span></h4></strong>
                            </Col>
                            <Col md="1" lg="1">
                            </Col>
                            <Col md="5" lg="5" className="text-center mr-2">
                                <strong><h4 > Severity : <span className=" text-capitalize" style={{ color: "grey", fontSize: "1.5rem" }}>{prescription.durInfo.seviorityLevel}</span></h4></strong>
                            </Col>
                        </Row>


                        {reactElement}
                    </div>
                }
                else {
                    modalBody = <div className="dur-interactions-headings">
                        <Row>
                            <Col md="5" lg="5" className="text-center ml-2">
                                <strong><h4 > Interraction Count : <span style={{ color: "teal", fontSize: "1.5rem" }}>{prescription.durInfo.interactionCount}</span></h4></strong>
                            </Col>
                            <Col md="1" lg="1">
                            </Col>
                            <Col md="5" lg="5" className="text-center mr-2">
                                <strong><h4 > Severity : <span className=" text-capitalize" style={{ color: "grey", fontSize: "1.5rem" }}>{prescription.durInfo.seviorityLevel}</span></h4></strong>
                            </Col>
                        </Row>


                        {reactElement}
                    </div>
                }
                // var reactHtml = ReactDOMServer.renderToStaticMarkup(reactElement);

                durModal = <div>
                    <Modal isOpen={this.state.showDur} backdrop={true} className="dur-modal bg-light" centered
                        dialogClassName="custom-modal" bsClass="my-modal">
                        <ModalHeader toggle={this.toggleDurModal} ><h4><strong>DRUG UTILIZATION REVIEW</strong></h4> </ModalHeader>
                        <ModalBody>
                            {modalBody}
                        </ModalBody>
                    </Modal>
                </div>
            }
            else {

            }
        }
        return durModal;
    }


    onChange = e => this.setState({
        [e.target.name]: e.target.value
    });

    toggle(headers) {
        this.setState({
            collapse: this.state.collapse === headers
                ? null
                : headers
        });
    }

    toggleModal() {
        this.setState({
            modal: !this.state.modal
        });
    }

    rejectModal() {
        this.setState({
            rejectModal: !this.state.rejectModal
        });
    }
    pmpRequiredModal() {
        this.setState({
            pmpRequiredModal: !this.state.pmpRequiredModal
        });
    }
    addDefaultSrc(ev) {
        ev.target.src = "";
    }
    pmpRequired = () => {
        this.state.ppmRequired = true;
        this.approve();
    }
    reject = () => {
        let orgId;
        if (this.props.auth.user.orgId)
            orgId = this.props.auth.user.orgId;
        else
            orgId = 1;
        let pending = this.props.mqtt.prescriptionByNumber;
        pending.rxInfo.rejectReason = this.state.rejectReason;
        pending.rxInfo.rxStatus = "Rejected";
        pending.isEditing = false;
        pending.patientInfo.patientAdditionalInfo.requireConsult = this.state.requireConsult;
        pending.patientInfo.patientAdditionalInfo.ppmRequired = this.state.ppmRequired;


        this
            .props
            .postPrescriptions(orgId, pending, this.props.history);
        this
            .props
            .presc_modal_view(false, {}, '', '');
    };

    approve = () => {
        let orgId;
        if (this.props.auth.user.orgId)
            orgId = this.props.auth.user.orgId;
        else
            orgId = 1;
        let pending = this.props.mqtt.prescriptionByNumber;
        pending.isEditing = false;
        pending.rxInfo.rxStatus = "Approved";

        pending.patientInfo.patientAdditionalInfo.requireConsult = this.state.requireConsult
        pending.patientInfo.patientAdditionalInfo.ppmRequired = this.state.ppmRequired;
        this
            .props
            .postPrescriptions(orgId, pending, this.props.history);
        this
            .props
            .presc_modal_view(false, {}, '', '');
    };

    moveToDraft = () => {
        let orgId;
        if (this.props.auth.user.orgId)
            orgId = this.props.auth.user.orgId;
        else
            orgId = 1;
        let pending = this.props.mqtt.prescriptionByNumber;
        pending.isEditing = false;
        pending.rxInfo.rxStatus = "Draft";
        pending.prescriptionStatus = "Draft";
        pending.patientInfo.patientAdditionalInfo.requireConsult = this.state.requireConsult
        pending.patientInfo.patientAdditionalInfo.ppmRequired = this.state.ppmRequired;
        this
            .props
            .postPrescriptions(orgId, pending, this.props.history);
        this
            .props
            .presc_modal_view(false, {}, '', '');
    };
    loadImages() {
        let prescImage,
            labelImage,
            pillImage,
            bottleImage;

        let addImages = []
        this.
            state
            .prescriptionByNumber
            .prescriptionImageUrls
            .map(images => {

                if (images.imageType === "prescriptionImage") {
                    prescImage = images.imageUrl;
                }
                if (images.imageType === "labelImage") {
                    labelImage = images.imageUrl;
                }
                if (images.imageType === "pillImage") {
                    pillImage = images.imageUrl;
                }
                if (images.imageType === "rxbottle") {
                    bottleImage = images.imageUrl;
                }
                if (images.imageType !== "prescriptionImage" && images.imageType !== "labelImage" && images.imageType !== "pillImage" && images.imageType !== "rxbottle" && images.imageType !== "ndcPillImage") {
                    addImages.push(images);
                }

            });
        let imagesList = [
            {
                "imageType": "prescriptionImage",
                "imageUrl": prescImage
            }, {
                "imageType": "labelImage",
                "imageUrl": labelImage
            }, {
                "imageType": "pillImage",
                "imageUrl": pillImage
            }, {
                "imageType": "rxbottle",
                "imageUrl": bottleImage
            }
        ]
        addImages.map(img => {
            imagesList.push(img)
        })
        return imagesList;
    }



    render() {
        const { roles, isAdmin } = this.props.auth.user;
        let accessRole = roles[0];
        const { loading } = this.props.mqtt;
        let prescriptionByNumber = this.state.prescriptionByNumber
        let pendingPrescriptions,
            imageUrls = [];
        let { collapse, headers, ndcImage } = this.state;
        if (loading) {
            pendingPrescriptions = <Spinner />;
        } else {

            if (Object.keys(prescriptionByNumber).length > 0) {

                let prescription = this.props.mqtt.prescriptionByNumber;
                let durItem = <div></div>;
                if (prescription.durInfo && prescription.durInfo.interactionCount) {
                    let seviorityLevel = prescription.durInfo.seviorityLevel;

                    if (seviorityLevel === "Major") {
                        durItem = <Menu compact className="ml-4" onClick={() => {
                            this.showDUR(true
                            );
                        }}>
                            <Menu.Item as='a' color="red">
                                {/* <Icon name='mail' /> */}
                                <span style={{ color: "red" }}> DUR Found</span>
                                <Label color='red' floating>
                                    {prescription.durInfo.interactionCount}
                                </Label>
                            </Menu.Item>
                        </Menu>
                    }
                    else if (seviorityLevel === "low") {
                        durItem = <Menu compact className="ml-4" onClick={() => {
                            this.showDUR(true
                            );
                        }}>
                            <Menu.Item as='a' color="#007bff">
                                {/* <Icon name='mail' /> */}
                                <span style={{ color: "#007bff" }}> DUR Found</span>
                                <Label color='#007bff' style={{ color: "white", backgroundColor: "#007bff" }} floating>
                                    {prescription.durInfo.interactionCount}
                                </Label>
                            </Menu.Item>
                        </Menu>
                    }
                    else if (seviorityLevel === "medium") {
                        durItem = <Menu compact className="ml-4" onClick={() => {
                            this.showDUR(true
                            );
                        }}>
                            <Menu.Item as='a' color="#007bff">
                                {/* <Icon name='mail' /> */}
                                <span style={{ color: "orange" }}> DUR Found</span>
                                <Label color='#007bff' style={{ color: "black", backgroundColor: "orange" }} floating>
                                    {prescription.durInfo.interactionCount}
                                </Label>
                            </Menu.Item>
                        </Menu>
                    }
                    else if (seviorityLevel === "Unknown") {
                        durItem = <Menu compact className="ml-4" onClick={() => {
                            this.showDUR(true
                            );
                        }}>
                            <Menu.Item as='a' color="grey">
                                {/* <Icon name='mail' /> */}
                                <span style={{ color: "black" }}> DUR Found</span>
                                <Label color='#007bff' style={{ color: "black", backgroundColor: "grey" }} floating>
                                    {prescription.durInfo.interactionCount}
                                </Label>
                            </Menu.Item>
                        </Menu>
                    }
                    else {
                        durItem = <Menu compact className="ml-4" onClick={() => {
                            this.showDUR(true
                            );
                        }}>
                            <Menu.Item as='a' color="grey">
                                {/* <Icon name='mail' /> */}
                                <span style={{ color: "black" }}> DUR Found</span>
                                <Label color='#007bff' style={{ color: "black", backgroundColor: "grey" }} floating>
                                    {prescription.durInfo.interactionCount}
                                </Label>
                            </Menu.Item>
                        </Menu>
                    }
                }
                prescriptionByNumber
                    .prescriptionImageUrls
                    .map(images => {
                    });
                let imageLists = this.loadImages();
                const listItems = imageLists.map(images => (
                    (!images.imageUrl.includes(".pdf")) ?
                        <Card key={images.imageType}>
                            <span className="text-center">
                                <h5>
                                    {images.imageType !== "ndcPillImage"
                                        ? (
                                            <div
                                                className=""
                                                style={{
                                                    position: "absolute",
                                                    textAlign: "center",
                                                    zIndex: "888",
                                                    color: "#ffff",
                                                    width: "100%",
                                                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                                                    opacity: "0.55",
                                                    padding: "6px 0",
                                                    fontWeight: "bolder",
                                                    fontSize: "15px",
                                                    borderRadius: "0.2rem"
                                                }}>
                                                {images
                                                    .imageType
                                                    .toUpperCase()}
                                            </div>
                                        )
                                        : ("")}
                                </h5>
                            </span>
                            <Magnifier
                                onError={this.addDefaultSrc}
                                src={images.imageType !== "ndcPillImage"
                                    ? images.imageUrl
                                    : ""}
                                mgShape="square"
                                zoomFactor={0.5}
                                mgWidth={400}
                                mgHeight={200} />
                        </Card> : <Card><a class="text-center" href={images.imageUrl} target='_'><i className="m-3 fa-lg fas fa-paperclip " />Prescription Attached</a></Card>
                ));
                pendingPrescriptions = (
                    <div>
                        <CardHeader
                            style={{
                                backgroundColor: "transparent",
                                borderBottom: "none"
                            }}>
                            <Row>
                                <Col lg="6" md="4">
                                    <div className="float-left">
                                        <h2
                                            className="text-capitalize"
                                            style={{
                                                margin: "none!important"
                                            }}>
                                            {prescriptionByNumber.patientInfo.firstName.toUpperCase()}{" "} {prescriptionByNumber.patientInfo.lastName.toUpperCase()}
                                        </h2>
                                        <h5 className="d-inline text-muted text-info font-bigger">
                                            <i class="fas fa-birthday-cake fa-1x mr-1 teal"></i> {prescriptionByNumber.patientInfo.dateOfBirth}
                                        </h5>
                                        <h5 className="d-inline text-muted ml-4 text-info font-bigger">
                                            <i class="fas fa-address-card mr-1 fa-1x teal"></i>{prescriptionByNumber.patientInfo.address}
                                        </h5>
                                        {this.getConsults(prescriptionByNumber, accessRole)}
                                    </div>
                                </Col>
                                <Col>
                                </Col>
                                <Col>
                                    {this.getPatientAllergyNotes(accessRole)}
                                </Col>
                                <Col>
                                    <Modal isOpen={this.state.rejectModal} toggle={this.toggleModal}>
                                        <ModalHeader>
                                            <h3>Please enter a reason for rejecting</h3>
                                        </ModalHeader>
                                        <ModalBody>
                                            <Input
                                                type="text"
                                                name="rejectReason"
                                                onChange={this.onChange}
                                                placeholder="Reject reason" />
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button color="secondary" onClick={this.reject}>
                                                Confirm
                                            </Button>
                                            <Button color="secondary" onClick={this.rejectModal}>
                                                Close
                                            </Button>
                                        </ModalFooter>
                                    </Modal>
                                    {/* {this.getConsults(prescriptionByNumber,accessRole)} */}
                                </Col>
                                <Col>
                                    {this.getButtonGroup(accessRole)}
                                    <Modal isOpen={this.state.pmpRequiredModal} toggle={this.pmpRequiredModal}>
                                        <ModalHeader>
                                            <h3>PMP Required?</h3>
                                        </ModalHeader>
                                        <ModalBody>
                                            <h4>Are you sure you want to mark PMP as required?</h4>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button color="success" onClick={this.pmpRequired}>
                                                Confirm & Approve
                                            </Button>
                                            <Button color="secondary" onClick={this.approve}>
                                                No & Approve
                                            </Button>
                                        </ModalFooter>
                                    </Modal>
                                    {/* {this.getConsults(prescriptionByNumber,accessRole)} */}
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardHeader
                            style={{
                                backgroundColor: "transparent",
                                borderBottom: "none"
                            }}>
                            <Row>
                                <Col md="5">
                                    <Row className="py-2">
                                        <Col md="5">
                                            <span className="font-style mb-1 text-capitalize">
                                                NDC: {prescriptionByNumber.rxInfo.ndcNumber}
                                            </span>
                                            {/* image:{this.ndcImage} */}
                                            <img src={this.state.ndcImage} alt="" />
                                        </Col>
                                        <Col md="7" className="pt-4">
                                            <Table>
                                                <tbody className="font-style">
                                                    <tr>
                                                        <td>
                                                            <div className="d-inline-block">
                                                                <i className="d-inline fas fa-edit text-info mr-2" />
                                                                <h3 className="d-inline">
                                                                    {prescriptionByNumber.rxInfo.prescriptionNumber
                                                                    }
                                                                </h3>
                                                                <Badge className="d-inline text-center" color="warning ml-2">
                                                                    Pending
                                                                </Badge>
                                                                {durItem}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span className="text-info" /> {prescriptionByNumber.rxInfo.rxName}-
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span className="text-info" /> {prescriptionByNumber.rxInfo.strength}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                    {Object
                                        .keys(headers)
                                        .map((key, index) => (<ListGroupCollapse
                                            key={index}
                                            content={headers[key]}
                                            isOpen={collapse === headers[key]}
                                            toggle={this.toggle}
                                            icon="fas fa-plus-square mr-2" />))}
                                </Col>
                                <div className="col-md-7 py-2">
                                    <Container className="photo-card-scroll">
                                        {listItems}
                                    </Container>
                                </div>
                            </Row>
                        </CardHeader>
                        <Modal1
                            size="fullscreen"
                            open={this.state.showAllergyModal}
                            onClose={this.closeAllergyModal}
                            className="view-modals px-3 py-3"
                            closeIcon
                        > <ModalHeader>Allergy Info Document</ModalHeader>
                            {this.state.isValidFilee ? (
                                this.state.fileTypee === 'pdf' ? (
                                    <iframe
                                        src={this.state.base64Dataa}
                                        width="100%"
                                        height="600px"
                                        title="Allergy Info PDF"
                                    />
                                ) : (
                                    <img
                                        src={this.state.base64Dataa}
                                        alt="Allergy Info Image"
                                        style={{
                                            maxWidth: '100%',
                                            maxHeight: '600px',
                                            display: 'block',
                                            margin: 'auto',
                                        }}
                                    />
                                )
                            ) : (
                                <div
                                    style={{
                                        width: '100%',
                                        height: '600px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: '1px dashed #ccc',
                                        backgroundColor: '#f9f9f9',
                                    }}
                                >
                                    <span style={{ color: '#777' }}>Patient Information Pending</span>
                                </div>
                            )}
                        </Modal1>
                    </div>
                );
            } else
                pendingPrescriptions = <h4>No prescriptions found</h4>;
        }

        let toShow = <div>
            {pendingPrescriptions}
            <div className="wrapper clearfix px-2 pt-2">
                <CardHeader
                    style={{
                        backgroundColor: "transparent",
                        borderBottom: "none"
                    }}>
                    {/* <Button color="info" size="md" className="mx-3" onClick={this.toggleModal}>
                        <i className="fas fa-times-circle mr-1"/>
                        Exit
                    </Button> */}
                    <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
                        <ModalHeader>
                            <h3>Warning</h3>
                        </ModalHeader>
                        <ModalBody>Your changes will be discarded! Proceed?</ModalBody>
                        <ModalFooter>
                            <Button tag={Link} to={"/pharmacist-dashboard"} color="secondary">
                                Confirm
                            </Button>
                            <Button color="secondary" onClick={this.toggleModal}>
                                Close
                            </Button>
                        </ModalFooter>
                    </Modal>
                    {this.getDurModal()}

                    {/*  */}


                </CardHeader>
            </div>
        </div>
        if (loading || Object.keys(prescriptionByNumber).length <= 0) {
            toShow = <Spinner />;
        }
        return (
            toShow
        );
    }

    getFileTypeFromUrl(url) {
        if (!url) return 'unknown';
        const extension = url.split('.').pop().toLowerCase();
        if (extension === 'pdf') return 'pdf';
        if (['jpg', 'jpeg', 'png'].includes(extension)) return 'image';
        return 'unknown';
    }
    getMimeTypeFromBase64(base64String) {
        if (!base64String) return 'application/octet-stream';
        try {
            if (base64String.startsWith('data:')) {
                return base64String.split(';')[0].split(':')[1];
            }
            const decoded = atob(base64String.slice(0, 50));
            const first = decoded.charCodeAt(0);
            if (first === 0x25 && decoded.includes('%PDF')) return 'application/pdf';
            if (first === 0xFF) return 'image/jpeg';
            if (first === 0x89) return 'image/png';
        } catch (e) { }
        return 'application/octet-stream';
    }


    isValidBase64File(base64String, fileType) {
        const mime = this.getMimeTypeFromBase64(base64String);
        if (!base64String || mime === 'application/octet-stream') return false;

        if (fileType === 'pdf') {
            return mime === 'application/pdf';
        } else if (fileType === 'image') {
            return mime.startsWith('image/');
        }
        return false;
    }



    getPatientAllergyNotes(accessRole) {
        let p_allergies = <span></span>;
        const patientInfo = this.state.prescriptionByNumber.patientInfo.patientAdditionalInfo;
        const notes = patientInfo?.notes?.trim();

        if (accessRole === "PHARMACIST" && patientInfo !== undefined) {
            const fileUrl = notes?.split(' , ')[0]?.trim();
            const fileType = this.getFileTypeFromUrl(fileUrl);
            const isPdf = fileType === 'pdf';
            const isImage = fileType === 'image';
            if (!isPdf && !isImage) {
                p_allergies = (
                    <Button1 basic color='grey' fluid='true' disabled>
                        <i className="fas fa-info-circle mr-2" />
                        Patient Info Pending
                    </Button1>
                );
            } else if (notes === "NKA") {
                p_allergies = (
                    <Button1 basic color='teal' fluid='true'>
                        <i className="fas fa-info-circle mr-2" />
                        Note On Allergies - {notes}
                    </Button1>
                );
            } else {
                p_allergies = (
                    <Button1 basic color='red' fluid='true' onClick={() => this.openAllergyModal()}>
                        <i className="fas fa-info-circle mr-2" />
                        Review Allergies
                    </Button1>
                );
            }
        }
        return p_allergies;
    }
    getButtonGroup(accessRole) {
        let bg;

        if (accessRole === "TECHNICIAN") {
            bg =
                <Button1
                    color="teal"
                    size="md"
                    className="mx-2"
                    onClick={() => {
                        this.moveToDraft();
                    }}>
                    Move to Draft
                </Button1>
        }
        else {
            bg = <Button1.Group className="button-column">

                <Button1
                    color="red"
                    size="medium"
                    className="mx-2"
                    onClick={() => {
                        this.rejectModal();
                    }}>
                    Reject
                </Button1>
                <Button1.Or />
                <Button1
                    color="teal"
                    size="medium"
                    className="mx-2"
                    onClick={() => {
                        this.pmpRequiredModal();
                    }}>
                    Approve
                </Button1>
            </Button1.Group>

        }

        return bg;
    }

    getConsults(prescriptionByNumber, accessRole) {
        let consultChecks = <div></div>
        if (Object.keys(prescriptionByNumber).length > 0 && accessRole === "PHARMACIST") {
            consultChecks = <div
                className="custom-control custom-checkbox m-0">
                <Input className="custom-control-input" id="requireConsult"
                    name="requireConsult"
                    type="checkbox" defaultChecked={prescriptionByNumber.patientInfo.patientAdditionalInfo.requireConsult}
                    onChange={this.handleChecked.bind(this)} />
                <label className="custom-control-label text-uppercase"
                    htmlFor="requireConsult"
                    style={{ fontSize: "1rem", color: "red", fontWeight: "bolder" }}>
                    Require Consult</label></div>
        }
        return consultChecks
    }
}


PendingView.propTypes = {
    getPrescriptionHistory: PropTypes.func.isRequired,
    getPrescriptions: PropTypes.func.isRequired,
    getPrescriptionByNumber: PropTypes.func.isRequired,
    postPrescriptions: PropTypes.func.isRequired,
    mqtt: PropTypes.object.isRequired,
    presc_modal_view: PropTypes.func.isRequired,
    getDurInfo: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({ mqtt: state.mqtt, auth: state.auth });

export default connect(mapStateToProps, { postPrescriptions, presc_modal_view, getPrescriptionHistory, getDurInfo, getPrescriptionByNumber, getPrescriptions, editingPrescriptions })((PendingView));
